<template>
    <section id="descargar" class="app-banner">
        <div class="app-banner__content">
            <div class="app-banner__text">
                <h2 class="app-banner__title">
                    Lleva la Quiniela a todas partes
                </h2>
                <p class="app-banner__desc">
                    Disponible para iOS, Android y dispositivos Huawei. <br />
                    Únete a usuarios ya ganando.
                </p>
                <StoreLinks />
            </div>
            <div class="app-banner__phone">
                <img
                    src="/images/app-phone.png"
                    alt="App Le Pegue"
                    class="phone-img"
                />
            </div>
        </div>
    </section>
</template>

<script>
import StoreLinks from "../../components/StoreLinks.vue";

export default {
    name: "AppBanner",
    components: { StoreLinks },
};
</script>

<style scoped>
.app-banner {
    background-color: #f5a623;
    border-radius: 16px;
    overflow: hidden;
    padding: 40px 48px;
    margin: 2rem 0;
}

.app-banner__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
}

.app-banner__text {
    flex: 1;
    max-width: 520px;
}

.app-banner__title {
    font-size: 28px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 10px;
}

.app-banner__desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.88);
    margin-bottom: 24px;
    line-height: 1.6;
    max-width: 380px;
}

.app-banner__phone {
    flex-shrink: 0;
}

.phone-img {
    max-height: 240px;
    object-fit: contain;
}

/* Responsive */
@media (max-width: 768px) {
    .app-banner {
        padding: 32px 24px;
    }

    .app-banner__content {
        flex-direction: column;
        text-align: center;
    }

    .app-banner__text {
        max-width: 100%;
    }

    .app-banner__desc {
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .app-banner__title {
        font-size: 24px;
    }
}
</style>
